import { Injectable, NgZone } from '@angular/core';
import { BehaviorSubject, defer, NEVER, Observable } from 'rxjs';
import { finalize, share } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class LoaderService {

  private loaderState$ = new BehaviorSubject<boolean>(false);

  constructor(private ngZone: NgZone) { }

  public readonly spinner$ = defer(() => {
    this.showLoader();
    return NEVER.pipe(
      finalize(() => {
        this.hideLoader();
      })
    );
  }).pipe(share());

  showLoader() {
    this.loaderState$.next(true);
  }

  hideLoader() {
    this.ngZone.run(() => this.loaderState$.next(false));
  }

  getLoaderState(): Observable<boolean> {
    return this.loaderState$.asObservable();
  }

}
